import * as React from "react";
import protectedRoute from "./protectedRoute";
import { styled } from "@mui/material/styles";
import HomeBar from "./HomeBar";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import datauniverseImg from "./images/Image20230928142439.png";
import Link from "@mui/material/Link";
import Container from "@mui/material/Container";
import Footer from "./Footer";

function Contact(props) {
  const CssLink = styled(Link)({
    color: "#00A3E0",
  });

  return (
    <React.Fragment>
      <HomeBar />
      <Box
        style={{
          padding: "0",
          height: "400px",
          minWidth: "1200px",
        }}
      >
        <img
          alt="メインバックグラウンド"
          src={datauniverseImg}
          style={{
            height: "400px",
            width: "100%",
            objectFit: "cover",
          }}
        />
      </Box>
      <Box
        style={{
          color: "white",
          fontSize: "24px",
          fontWeight: "bold",
          paddingTop: "20px",
          paddingLeft: "52px",
        }}
      >
        CONTACT
      </Box>
      <Container
        style={{
          backgroundColor: "#303234",
          minWidth: "1200px",
          padding: "0px",
        }}
        maxWidth={false}
      >
        <Box
          style={{
            color: "white",
            fontSize: "16px",
            paddingTop: "10px",
            paddingLeft: "68px",
          }}
        >
          <Typography
            style={{ fontFamily: "Noto Sans JP, Meiryo, -apple-system" }}
          >
            本サイトについてご不明な点やお困りのことがございましたら、お気軽にお問い合わせください。
          </Typography>
          <Typography
            style={{ fontFamily: "Noto Sans JP, Meiryo, -apple-system" }}
          >
            データに関しては、各データジャケット下部に記載されている「データに関する問い合わせ先」からお問い合わせください。
          </Typography>
        </Box>
        <Box
          style={{
            color: "white",
            fontSize: "16px",
            fontWeight: "bold",
            paddingTop: "20px",
            paddingLeft: "52px",
            paddingBottom: "20px",
            fontFamily: "Noto Sans JP, Meiryo, -apple-system",
          }}
          sx={{
            borderBottom: 1,
            borderColor: "white",
          }}
        >
          Deloitte Tohmatsu Consulting LLC DATAUNIVERSE事務局
        </Box>
        <Box
          style={{
            color: "white",
            fontSize: "16px",
            paddingTop: "10px",
            paddingLeft: "68px",
          }}
        >
          <Typography
            style={{ fontFamily: "Noto Sans JP, Meiryo, -apple-system" }}
          >
            メールアドレス：
            <CssLink
              href={"mailto:dtcdatauniverse_usersupporttm@tohmatsu.co.jp"}
            >
              {"dtcdatauniverse_usersupporttm@tohmatsu.co.jp"}
            </CssLink>
          </Typography>
        </Box>
      </Container>
      <Footer fixed={true} />
    </React.Fragment>
  );
}

export default protectedRoute(Contact);
